import { StorageHelper } from "../helpers/StorageHelper";
import { encryptAES } from "../helpers/utils";
import { IAuthRequest } from "../interfaces/IAuthRequest";
import { IAuthResponse, IAuthToken } from "../interfaces/IAuthResponse";
import { IPasswordResetRequest } from "../interfaces/IPasswordResetRequest";
import { IResetPasswordCodeAuthRequest, IResetPasswordCodeAuthResponse } from "../interfaces/IResetPasswordCodeAuth";
import { ApiService } from "./apiService";

export const authenticate = async (auth: IAuthRequest): Promise<IAuthResponse> => {
	return (await ApiService.retryPost(`${process.env.REACT_APP_API_URL}/api/auth/authenticate`, getEncryptedAuthRequest(auth))).data;
};

export const passwordReset = async (passwordReset: IPasswordResetRequest): Promise<IPasswordResetRequest> => {
	passwordReset.appUrl = process.env.REACT_APP_API_URL!;
	return (await ApiService.retryPost(`${process.env.REACT_APP_API_URL}/api/auth/resetpassword`, passwordReset)).data;
};

export const resetPasswordCodeAuth = async (authRequest: IResetPasswordCodeAuthRequest): Promise<IResetPasswordCodeAuthResponse> => {
	return (await ApiService.retryPost(`${process.env.REACT_APP_API_URL}/api/auth/resetpasswordcodeauth`, authRequest)).data;
};

export const resetPasswordUserAuth = async (auth: IAuthRequest): Promise<IAuthResponse> => {
	return (await ApiService.retryPost(`${process.env.REACT_APP_API_URL}/api/auth/resetpassworduserauth`, getEncryptedAuthRequest(auth))).data;
};

export const refreshUserAccessToken = async (user: IAuthResponse): Promise<boolean> => {
	try {
		const refreshedToken: IAuthToken = (await ApiService.retryGet(`${process.env.REACT_APP_API_URL}/api/Auth/RefreshToken/${user.id}`, { headers: { Authorization: `Bearer ${user.token.jwt}` } })).data;
		if (refreshedToken) {
			ApiService.setAuthToken(refreshedToken);
			user.token = refreshedToken;
			StorageHelper.setItem("user", JSON.stringify(user));
			return true;
		}
	} catch (error) {
	}
	return false;
};

const getEncryptedAuthRequest = (auth: IAuthRequest): IAuthRequest => {
	return {
		email: auth.email,
		password: encryptAES(auth.password)
	};
}